import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import FieldError from '../../../../../shared/fields-errors/field-error';
import { useEffect } from 'react';

function DateField({ fieldInfo, parentIndex, entityID, CustomFieldID }) {
    const { register, formState: { errors }, setValue } = useFormContext();

    useEffect(() => {
        if (entityID) {
            setValue(`field_answers.${parentIndex}.answers.${0}.entity_id`, entityID);
        }
    }, [entityID]);

    useEffect(() => {
        if (CustomFieldID) {
            setValue(`field_answers.${parentIndex}.answers.${0}.custom_field_id`, CustomFieldID);
        }
    }, [CustomFieldID]);

    return (
        <>
            <Form.Group  >
                <Form.Label>{fieldInfo?.field_label}</Form.Label>
                <Form.Control
                    className='form-control'
                    {...register(`field_answers.${parentIndex}.answers.${0}.date_value`, {
                        required: {
                            value: fieldInfo?.field_is_required,
                            message: 'Field is required'
                        }
                    })}
                    type="date"
                     />
                {errors?.field_answers?.[parentIndex]?.answers?.[0]?.date_value ?
                    <FieldError message={errors?.field_answers[parentIndex]?.answers[0]?.date_value?.message} /> : ''}
            </Form.Group>
            {
                fieldInfo?.field_description ? 
                <p className='text-secondary f-12-small'>{fieldInfo?.field_description}</p> : ''
            }
            
            {
                CustomFieldID ?
                    <input type='hidden' {...register(`field_answers.${parentIndex}.answers.${0}.custom_field_id`, {
                        value: CustomFieldID
                    })} /> : ''
            }
            {
                entityID ?
                    <input type='hidden' {...register(`field_answers.${parentIndex}.answers.${0}.entity_id`, {
                        value: entityID
                    })} /> : ''
            }
        </>
    );
}

export default DateField;